import React from 'react';
import { FileText, ShieldCheck, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

/**
 * The previous page was a generic invoice CRUD screen. Its rows were not the
 * visit invoice source of truth and displayed invented paid/remaining values.
 * Invoice issuance stays in Vehicle Details, where the backend can enforce a
 * finalized visit and the one-invoice-per-visit constraint.
 */
const Invoices = () => {
    const navigate = useNavigate();
    return (
        <main className="container mx-auto max-w-3xl p-6" dir="rtl" data-testid="invoices-page">
            <section className="rounded-2xl border border-blue-200 bg-white p-6 shadow-sm">
                <div className="flex items-start gap-3">
                    <span className="rounded-xl bg-blue-50 p-3 text-blue-700"><FileText size={28} /></span>
                    <div>
                        <h1 className="text-2xl font-bold text-gray-900">فواتير الزيارات</h1>
                        <p className="mt-1 text-sm text-gray-600">تُصدر الفاتورة من بطاقة الزيارة بعد اعتمادها المالي.</p>
                    </div>
                </div>
                <div className="mt-6 rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900">
                    <div className="flex gap-2"><ShieldCheck size={18} className="mt-0.5 shrink-0" />
                        <p>أوقفنا شاشة الفواتير العامة لأنها كانت تنشئ وتعرض سجلات غير مرتبطة بالزيارة، وتخمن المدفوع والمتبقي. لا تظهر هنا بيانات بديلة أو أرقام تقديرية.</p>
                    </div>
                </div>
                <ol className="mt-6 list-decimal space-y-2 pr-5 text-sm text-gray-700">
                    <li>افتح بطاقة المركبة.</li>
                    <li>اختر الزيارة النهائية واعتمدها ماليًا.</li>
                    <li>استخدم طباعة الفاتورة في بطاقة الزيارة لإصدار الفاتورة القانونية.</li>
                </ol>
                <button type="button" onClick={() => navigate('/')} className="mt-6 inline-flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700" data-testid="invoices-open-vehicles">
                    <ArrowRight size={16} /> فتح لوحة المركبات
                </button>
            </section>
        </main>
    );
};

export default Invoices;
